<template>
  <section class="assessment-content">
    <div class="assessment-container">

    <div class="title">
        {{ chapterHeading }}
    </div>

    <carousel class="carousel" :items=items :nav=nav :stagePadding=stagePadding :dots=dots :margin=margin>
        <v-card>
          <ul class="qmm-link">
            <li>
              <a rel="noopener noreferrer" href="https://testhub.cambridge.edu.au/assessment/h+CclHy5GTU=" target="_blank">Checkpoints NSW Maths Advanced 2020 - 2021</a>
            </li>
            <li>
              <a rel="noopener noreferrer" href="https://testhub.cambridge.edu.au/assessment/ruMlmZVTzZ0=" target="_blank">Checkpoints NSW Maths Extension 1 2020 - 2021</a>
            </li>
            <li>
              <a rel="noopener noreferrer" href="https://testhub.cambridge.edu.au/assessment/Z0EWTzKJ+vo=" target="_blank">Checkpoints NSW Maths Standard 2019 - 2020</a>
            </li>
          </ul>
        </v-card>
    </carousel>
    </div>
  </section>
</template>

<script lang="js">
import carousel from 'vue-owl-carousel'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'QMM',
  components: {
    carousel
  },
  mounted () {
    this.getChapterMap()
    this.getChapterValueFromKey(this.chapterTitle)
  },
  data: () => ({
    nav: false,
    items: 1,
    stagePadding: 35,
    dots: false,
    margin: 10,
    chapterObject: ''
  }),
  methods: {
    ...mapActions({
      getChapterMap: 'GET_CHAPTER_MAP'
    }),
    getChapterValueFromKey (chapterTitle) {
      this.chapterObject = this.chapterMap.get(chapterTitle)
    }
  },
  computed: {
    ...mapGetters({
      chapterMap: 'CHAPTER_MAP',
      chapterHeading: 'CHAPTER_HEADING',
      chapterTitle: 'CHAPTER_TITLE'
    })
  }
}
</script>

<style scoped lang="scss">
  .assessment-content {
    background: url("../assets/images/math-background.jpg") no-repeat center
      right / cover;
    height: 100%;
    .assessment-container {
      max-width: 1000px;
      margin: auto;
      .carousel {
        padding: 10px 0px 10px 0px;
        .v-card {
          padding: 10px;
          border-radius: 15px;
          .qmm-link li a {
            text-decoration: none;
            color: #000;
            cursor: pointer;
          }
          .qmm-link li a:hover, .qmm-link li a:active {
            text-decoration: underline;
            color: #0000FF;
            cursor: pointer;
          }
        }
      }
    }
  }
</style>
